import React from 'react';

import { useConversionTable } from 'hooks';
import { useCXI } from 'modules/cxi/useCXI';

import { Option } from '../components/option/Option';

import * as Form from '../components/form';

export const BusinessTypes = () => {
    const { t, vars, addVars } = useCXI();
    const conv = useConversionTable(['businessType']);
    const data = vars.profile.profile.businessTypes;

    const handleChange = value => {
        let newData = [...data];
        if (data.includes(value)) {
            newData = data.filter(v => v !== value);
        } else {
            newData.push(value);
        }

        const profile = {
            ...vars.profile,
            profile: {
                ...vars.profile.profile,
                businessTypes: [...newData],
            },
        };
        addVars({ profile });
    };

    return (
        <Form.Form name="BusinessTypes">
            <Form.Title>{t('setup.Titles.businessTypes')}</Form.Title>

            <Form.OptionsContainer>
                {Object.keys(conv.businessType)
                    .map(value => parseInt(value, 10))
                    .map(value => (
                        <Option
                            label={conv.businessType[String(value)]}
                            value={value}
                            key={value}
                            checked={!!data.includes(value)}
                            onChange={() => handleChange(value)}
                        />
                    ))}
            </Form.OptionsContainer>
        </Form.Form>
    );
};
